module.exports = __webpack_public_path__ + "img/98.81d0cdf8.jpg";